<template>
    <div>
        <div class="container">
            <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

            <div class="row">
                <div class="col-lg-3">
                    <div class="rules-nav mb-32">
                        <nav>
                            <ul>
                                <li>
                                    <router-link class="h4 color-text-white" to="/projects">Снято на технику MRental</router-link>
                                </li>
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/tv">MRental TV</router-link>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white" to="/projects/support">Поддержка проектов</router-link>-->
<!--                                </li>-->
<!--                                <li>-->
<!--                                    <router-link class="h4 color-text-white active-rules" to="/projects/application">Оставить заявку</router-link>-->
<!--                                </li>-->

                            </ul>
                        </nav>
                    </div>

                    <div class="d-none d-xl-block">
                        <catalog-categories></catalog-categories>
                    </div>

                </div>
                <div class="col-xl-9">
                    <div class="box-shadow">
                        <h1 class="as-h2 mb-28">Оставить заявку</h1>
                        <div class="title-4">Раздел находится в разработке.</div>

                        <!--                        <div class="grid-container">-->
                        <!--                            <div class="box-grid" v-for="(item, i) in items"-->
                        <!--                                 v-bind:key="i">-->
                        <!--                                <router-link :to="'/projects/' + item.slug">-->
                        <!--                                    <img :src="'/storage/' + item.image" :alt="item.title">-->
                        <!--                                    <h4 class="color-text-white">{{item.title}}</h4>-->
                        <!--                                </router-link>-->
                        <!--                            </div>-->
                        <!--                        </div>-->

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                items: null,
                breadcrumb: [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: 'Оставить заявку',
                        active: true
                    }
                ],
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                // let url = '/api/projects';
                // axios.get(url)
                //     .then(response => {
                //         this.projects_bd = response.data.projects
                //     })
            },
        }
    }
</script>
